export enum BidCondition {
  UN_PRICE = 'un_price',
  OVERPRICE = 'overprice',
  RECOMMEND_PRICE = 'recommend_price',
}
